import React, { useState } from "react";
import styled from "styled-components";

//Curriculum Data
const curriculum = [
   {
      id: 1,
      name: "nigerian",
      label: "Nigerian Curriculum",
   },
   {
      id: 2,
      name: "ghanaian",
      label: "Ghanaian Curriculum",
   },
   {
      id: 3,
      name: "kenyan",
      label: "Kenyan Curriculum",
   },
   {
      id: 4,
      name: "american",
      label: "American Curriculum",
   },
   {
      id: 5,
      name: "british_american",
      label: "British / American Curriculum",
   },
   {
      id: 6,
      name: "nigerian_british",
      label: "Nigerian / British Curriculum",
   },
   {
      id: 7,
      name: "nigerian_american",
      label: "Nigerian / American Curriculum",
   },
   {
      id: 8,
      name: "canadian",
      label: "Canadian Curriculum",
   },
   {
      id: 9,
      name: "british",
      label: "British Curriculum",
   },
   {
      id: 10,
      name: "islamic_education",
      label: "Islamic Education",
   },
];

//Checkbox styles
export const Div = styled.div<{ fullWidth?: boolean | undefined }>`
   ${({ fullWidth }) => fullWidth && "width: 100%;"}
   position: relative;
   display: inline-block;
   width: 100%;
`;

export const Label = styled.label`
   pointer-events: none;
   color: ${({ theme }) => theme.colors?.grey};
   white-space: nowrap;
   margin-bottom: 0.3rem;

   font-size: 1.4rem;
   display: block;
   font-weight: 400;
   color: ${({ theme }) => theme.colors?.black};

   ${Div}:focus-within & {
      color: ${({ theme }) => theme.colors?.primary};
   }
`;

export const InputFieldWrapperDiv = styled.div`
   position: relative;
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
   grid-column-gap: 3.688rem;
   grid-row-gap: 2rem;
   width: 100%;
`;

export const CheckBoxInput = styled.input`
   width: 15px;
   height: 15px;
   cursor: pointer;
`;

export const CheckBoxLabel = styled.label`
   margin-left: 10px;
   font-weight: normal;
   font-size: 14.4px;
   line-height: 20px;
   cursor: pointer;
`;

interface Props {
   handleCurriculumFilters: (x: any) => {};
   checkedCurriculum: string[];
   data: Record<string, string>;
   isEdit: boolean;
}

interface IItem {
   id: string | number;
   name: string | never;
   label: string;
}

const CheckBox: React.FC<Props> = ({
   handleCurriculumFilters,
   checkedCurriculum,
   data,
   isEdit,
}) => {
   const [checked, setChecked] = useState(checkedCurriculum);

   const handleToggle = (value: string) => {
      const currentIndex = checkedCurriculum.indexOf(value as never);
      const newChecked = [...checkedCurriculum];

      if (currentIndex === -1) {
         newChecked.push(value as never);
      } else {
         newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
      handleCurriculumFilters(newChecked);
   };

   if (!isEdit && data) {
      return (
         <Div>
            <Label>Curriculum</Label>
            <InputFieldWrapperDiv>
               {curriculum.map((item: IItem, index) => (
                  <div key={index}>
                     <CheckBoxInput
                        id={item.name}
                        type="checkbox"
                        onChange={() => handleToggle(item.name)}
                        checked={checked.indexOf(item.name as never) === -1 ? false : true}
                        name={item.name}
                     />
                     <CheckBoxLabel htmlFor={item.name}>{item.label}</CheckBoxLabel>
                  </div>
               ))}
            </InputFieldWrapperDiv>
         </Div>
      );
   }
   return (
      <Div>
         <Label>Curriculum</Label>
         <InputFieldWrapperDiv>
            {curriculum.map((item: IItem, index) => (
               <div key={index}>
                  <CheckBoxInput
                     id={item.name}
                     type="checkbox"
                     onChange={() => handleToggle(item.name)}
                     checked={checkedCurriculum.indexOf(item.name as never) === -1 ? false : true}
                     name={item.name}
                  />
                  <CheckBoxLabel htmlFor={item.name}>{item.label}</CheckBoxLabel>
               </div>
            ))}
         </InputFieldWrapperDiv>
      </Div>
   );
};

export default CheckBox;
